import * as React from "react";
import { Component } from "react";
import { Table } from "react-bootstrap";
import { Redirect } from "react-router";
import "src/css/components/projects/project/reports/annualsummary/annualsummarybymonth.css";
import { TIMEOUT } from "src/global";
import { TSMT$NumberFormatter } from "src/lib/NumberFormatter";
import {
  IAnnualSummaryByMonthProps,
  IAnnualSummaryByMonthRow,
  IAnnualSummaryByMonthState,
} from "./interfaces";

export default class AnnualSummaryByMonth extends Component<
  IAnnualSummaryByMonthProps,
  IAnnualSummaryByMonthState
> {
  public constructor(props: IAnnualSummaryByMonthProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    setTimeout(() => {
      this.setState({ loading: false });
    }, TIMEOUT);
  }

  public render() {
    if (!this.props.appService.isAuthenticated()) {
      return <Redirect to="/login" />;
    }

    if (window.screen.availWidth <= 1200) {
      return (
        <div className="container">
          <p>
            There is not enough horizontal space to display this report. Increase your window size.
          </p>
        </div>
      );
    }

    return (
      <div className="flex">
        <div className="row">
          <Table className="table-report">
            <colgroup>
              <col width="100" />
              <col width="100" />
              <col width="100" />
              <col width="50" />
              <col width="50" />
              <col width="50" />
              {this.props.checkEstimatedGeneration ? <col width="50" /> : null}
              <col width="50" />
              <col width="50" />
              <col width="50" />
              <col width="50" />
              <col width="75" />
              {this.props.checkEstimatedGeneration ? <col width="50" /> : null}
              <col width="75" />
              <col width="100" />
              {this.props.checkEstimatedGeneration ? <col width="50" /> : null}
              {this.props.checkEstimatedGeneration ? <col width="80" /> : null}
            </colgroup>
            <thead>
              <tr>
                <th colSpan={16}>Summary by Month: {this.props.projectLocation}</th>
              </tr>
              <tr>
                <th className="table-report-header">Statement Date</th>
                <th className="table-report-header">Service Start</th>
                <th className="table-report-header">Service End</th>
                <th className="table-report-header">Number of Days</th>
                <th className="table-report-header">Total Delivered (kWh)</th>
                <th className="table-report-header">Total Solar Generated</th>
                {this.props.checkEstimatedGeneration ? (
                  <th className="table-report-header">Met Estimated Generation (avg)</th>
                ) : null}
                <th className="table-report-header">Total Solar Received</th>
                <th className="table-report-header">Net Grid Usage</th>
                <th className="table-report-header">Solar Directly Used</th>
                <th className="table-report-header">Total Household Usage</th>
                <th className="table-report-header">Percent Solar Generated</th>
                {this.props.checkEstimatedGeneration ? (
                  <th className="table-report-header">Lease Payment</th>
                ) : null}
                <th className="table-report-header">Electric Bill Amount</th>
                <th className="table-report-header">Total Cost</th>
                {this.props.checkEstimatedGeneration ? (
                  <th className="table-report-header">Budget Payment</th>
                ) : null}
                {this.props.checkEstimatedGeneration ? (
                  <th className="table-report-header">Electricity Savings</th>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {this.props.annualSummaryByMonth.map(summary => (
                <tr key={summary.id}>
                  <td className="table-report-cell table-date">
                    {new Date(summary.statementDate).toISOString().substring(0, 10)}
                  </td>
                  <td className="table-report-cell table-date">
                    {new Date(summary.serviceStart).toISOString().substring(0, 10)}
                  </td>
                  <td className="table-report-cell table-date">
                    {new Date(summary.serviceEnd).toISOString().substring(0, 10)}
                  </td>
                  <td className="table-report-cell table-int">{summary.numberOfDays}</td>
                  <td className="table-report-cell table-kwh">{summary.totalDelivered}</td>
                  <td className="table-report-cell table-kwh">{summary.totalSolarGenerated}</td>
                  {this.props.checkEstimatedGeneration ? (
                    <td className="table-report-cell table-boolean">
                      {summary.checkEstimate &&
                      summary.totalSolarGenerated >= summary.avagEstimatedPower ? (
                        <div style={{ fontSize: "12px", fontWeight: "bolder", color: "green" }}>
                          Yes
                        </div>
                      ) : (
                        <div style={{ color: "red" }}>No</div>
                      )}
                    </td>
                  ) : null}
                  <td className="table-report-cell table-kwh">{summary.totalSolarRecived}</td>
                  <td className="table-report-cell table-kwh">{summary.netGridUsage}</td>
                  <td className="table-report-cell table-kwh">{summary.solarDirectlyUsed}</td>
                  <td className="table-report-cell table-kwh">{summary.totalHouseholdUsage}</td>
                  <td className="table-report-cell table-kwh">
                    {TSMT$NumberFormatter.formatNumber(
                      summary.percentSolarGenerated,
                      2,
                      false,
                      false
                    )}
                    %
                  </td>
                  {this.props.checkEstimatedGeneration ? (
                    <td className="table-report-cell table-dollars">
                      $ {TSMT$NumberFormatter.toFixed(summary.leasePayment, 2)}
                    </td>
                  ) : null}
                  <td className="table-report-cell table-dollars">
                    $ {TSMT$NumberFormatter.toFixed(summary.electricBillAmount, 2)}
                  </td>
                  <td className="table-report-cell table-dollars">
                    $ {TSMT$NumberFormatter.toFixed(summary.totalCost, 2)}
                  </td>
                  {this.props.checkEstimatedGeneration ? (
                    <td className="table-report-cell table-dollars">
                      $ {TSMT$NumberFormatter.toFixed(summary.budgetPayment, 2)}
                    </td>
                  ) : null}
                  {this.props.checkEstimatedGeneration ? (
                    <td className="table-report-cell table-dollars">
                      {summary.electricitySavings < 0.0
                        ? this.formatNegativeSavings(summary)
                        : this.formatPositiveSavings(summary)}
                    </td>
                  ) : null}
                </tr>
              ))}
              {this.props.annualSummaryByMonth.length === 0 ? (
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      padding: "15px",
                      color: "red",
                      fontSize: "16px",
                      fontWeight: "bold",
                    }}
                    colSpan={16}
                  >
                    There is no data to summarize.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }

  private formatPositiveSavings(summary: IAnnualSummaryByMonthRow) {
    if (summary.electricitySavings < 10.0) {
      return (
        <div style={{ fontWeight: "bolder", color: "green", fontFamily: "Courier New" }}>
          $&nbsp;&nbsp;&nbsp;{TSMT$NumberFormatter.toFixed(summary.electricitySavings, 2)}
        </div>
      );
    } else {
      return (
        <div style={{ fontWeight: "bolder", color: "green", fontFamily: "Courier New" }}>
          $&nbsp;&nbsp;{TSMT$NumberFormatter.toFixed(summary.electricitySavings, 2)}
        </div>
      );
    }
  }

  private formatNegativeSavings(summary: IAnnualSummaryByMonthRow) {
    if (summary.electricitySavings > -10) {
      return (
        <div style={{ color: "red", fontFamily: "Courier New" }}>
          $&nbsp;&nbsp;{TSMT$NumberFormatter.toFixed(summary.electricitySavings, 2)}
        </div>
      );
    } else {
      return (
        <div style={{ color: "red", fontFamily: "Courier New" }}>
          $&nbsp;{TSMT$NumberFormatter.toFixed(summary.electricitySavings, 2)}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/reports/annualsummary/AnnualSummaryByMonth.tsx